import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const CameraIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="101"
      height="100"
      viewBox="0 0 101 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2026_15606)">
        <mask
          id="mask0_2026_15606"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="101"
          height="100"
        >
          <path d="M0.5 1.52588e-05H100.5V100H0.5V1.52588e-05Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2026_15606)">
          <path
            d="M66.1663 11.6604H74.9089C75.7325 11.6604 76.4003 12.3282 76.4003 13.152V18.1727H64.6747V13.152C64.6747 12.3282 65.3425 11.6604 66.1663 11.6604Z"
            fill="#E175A5"
          />
          <path
            d="M35.6067 19.8445V49.2168C35.6067 50.14 36.3551 50.8885 37.2784 50.8885H81.1256C82.0487 50.8885 82.7971 50.14 82.7971 49.2168V19.8445C82.7971 18.9213 82.0487 18.1728 81.1256 18.1728H37.2784C36.3551 18.1728 35.6067 18.9213 35.6067 19.8445Z"
            fill="#EFEDEF"
          />
          <path
            d="M81.1255 18.1728H76.7679C77.6911 18.173 78.4396 18.9215 78.4396 19.8445V49.2168C78.4396 50.14 77.6911 50.8885 76.7677 50.8885H81.1255C82.0488 50.8885 82.7972 50.14 82.7972 49.2168V19.8445C82.7972 18.9213 82.0488 18.1728 81.1255 18.1728Z"
            fill="#E3E0E4"
          />
          <path
            d="M72.4077 34.5306C72.4077 38.8015 68.9454 42.2637 64.6747 42.2637C60.4038 42.2637 56.9417 38.8015 56.9417 34.5306C56.9417 30.2598 60.4038 26.7976 64.6747 26.7976C68.9454 26.7976 72.4077 30.2598 72.4077 34.5306Z"
            fill="#5766CC"
          />
          <path
            d="M45.5682 25.753C43.7946 25.753 42.3567 27.1909 42.3567 28.9648C42.3567 30.7384 43.7946 32.1763 45.5682 32.1763C47.342 32.1763 48.7797 30.7384 48.7797 28.9648C48.7797 27.1909 47.342 25.753 45.5682 25.753Z"
            fill="#EEC06B"
          />
          <path
            d="M52.1765 49.145H42.4023C37.7835 49.145 33.3783 47.2001 30.2662 43.787L24.1783 37.1098C21.7917 34.4922 21.4695 30.5946 23.3943 27.6208L32.2162 13.9897C32.8853 12.9555 34.2582 12.6452 35.3072 13.2907L42.1898 17.5258C44.2169 18.7733 46.8712 18.1413 48.1187 16.1143L48.7808 15.0385C49.2472 14.2809 49.0109 13.2885 48.2531 12.8221L31.2751 2.37583C30.147 1.6815 28.6738 1.98169 27.907 3.06196L9.9519 28.3604C9.04194 29.642 8.55347 31.1749 8.55347 32.7465V79.469H27.8259V66.5711C27.8259 65.4625 28.3847 64.4192 29.3267 63.8348C31.3384 62.5874 34.0029 59.9147 35.3781 58.4708C35.9708 57.8485 36.7916 57.4971 37.6511 57.4971H52.1765C54.483 57.4971 56.3527 55.6272 56.3527 53.3209C56.3527 51.0147 54.483 49.145 52.1765 49.145Z"
            fill="#FFCDBE"
          />
          <path
            d="M36.9761 49.145H42.4023C37.7835 49.145 33.3783 47.2 30.2663 43.787L24.1785 37.1098C21.7917 34.4922 21.4695 30.5946 23.3943 27.6207L32.2162 13.9897C32.796 13.0936 33.9037 12.7422 34.8716 13.0838L31.4296 10.9659C30.3804 10.3203 29.008 10.6307 28.3384 11.6649L17.9679 27.6207C16.0433 30.5946 16.3654 34.4922 18.7519 37.1098L24.84 43.787C27.9519 47.2 32.3574 49.145 36.9761 49.145Z"
            fill="#EBAE9D"
          />
          <path
            d="M48.2532 12.8221L44.4012 10.4522C45.1592 10.9184 45.3696 11.9561 44.9034 12.7139L44.2413 13.7897C43.1073 15.6317 40.8125 16.3163 38.8821 15.4903L42.1899 17.5259C44.217 18.7731 46.8713 18.1413 48.1188 16.1143L48.7809 15.0387C49.2473 14.2809 49.0112 13.2884 48.2532 12.8221Z"
            fill="#EBAE9D"
          />
          <path
            d="M52.1765 49.145H46.7504C49.0564 49.145 50.9263 51.0147 50.9263 53.3209C50.9263 55.6272 49.0566 57.4971 46.7504 57.4971H32.2248C31.3654 57.4971 30.5445 57.8485 29.9519 58.4708C28.5765 59.9149 25.9119 62.5874 23.9006 63.8348C22.9582 64.4192 22.3998 65.4625 22.3998 66.5711V79.469H27.826V66.5711C27.826 65.4625 28.3847 64.4192 29.3267 63.8348C31.3383 62.5874 34.0029 59.9149 35.3781 58.4708C35.9707 57.8485 36.7916 57.4971 37.6511 57.4971H52.1765C54.483 57.4971 56.3527 55.6272 56.3527 53.3209C56.3527 51.0147 54.483 49.145 52.1765 49.145Z"
            fill="#EBAE9D"
          />
          <path
            d="M29.9409 77.6169H6.43918C5.07278 77.6169 3.96497 78.7247 3.96497 80.0911V98.5353H32.4152V80.0911C32.4152 78.7247 31.3073 77.6169 29.9409 77.6169Z"
            fill="#80B6FC"
          />
          <path
            d="M29.9409 77.6169H24.7919C26.1583 77.6169 27.2661 78.7247 27.2661 80.0911V98.5352H32.4151V80.0911C32.4151 78.7247 31.3073 77.6169 29.9409 77.6169Z"
            fill="#5392F9"
          />
          <path
            d="M64.6747 18.1728V13.1521C64.6747 12.3283 65.3425 11.6605 66.1663 11.6605H74.9087C75.7325 11.6605 76.4003 12.3283 76.4003 13.1521V18.1728"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.797 42.9921V49.2167C82.797 50.1406 82.0489 50.8886 81.1249 50.8886H55.5704"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.6074 47.6718V19.8437C35.6074 18.9218 36.3555 18.1718 37.2773 18.1718H81.125C82.0488 18.1718 82.7969 18.9218 82.7969 19.8437V36.1562"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.4077 34.5306C72.4077 38.8015 68.9454 42.2637 64.6747 42.2637C60.4038 42.2637 56.9417 38.8015 56.9417 34.5306C56.9417 30.2598 60.4038 26.7976 64.6747 26.7976C68.9454 26.7976 72.4077 30.2598 72.4077 34.5306Z"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.5682 25.753C43.7946 25.753 42.3567 27.1909 42.3567 28.9648C42.3567 30.7384 43.7946 32.1763 45.5682 32.1763C47.342 32.1763 48.7797 30.7384 48.7797 28.9648C48.7797 27.1909 47.342 25.753 45.5682 25.753Z"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.55286 54.1386V32.746C8.55286 31.1757 9.04309 29.6425 9.9511 28.3593L27.9064 3.06242C28.6739 1.98234 30.1466 1.68156 31.2755 2.37492L48.254 12.8222C49.0116 13.289 49.248 14.2812 48.7814 15.039L48.1191 16.1152C46.871 18.1405 44.2169 18.7734 42.1896 17.5253L35.3066 13.2909C34.2577 12.6444 32.8847 12.955 32.2167 13.9902L23.3945 27.621C21.4689 30.5937 21.7909 34.4921 24.1779 37.1093L30.2657 43.787C33.3788 47.1991 37.7831 49.1444 42.4025 49.1444H52.1759C54.4823 49.1444 56.3534 51.0155 56.3534 53.3202C56.3534 55.6269 54.4823 57.498 52.1759 57.498H37.6503C36.7909 57.498 35.9708 57.8476 35.379 58.4706C34.004 59.914 31.3378 62.5878 29.3261 63.8339C28.3847 64.4198 27.8263 65.4628 27.8263 66.5702V77.6171"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.55286 77.6171V60.9745"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.4152 98.5349V80.091C32.4152 78.7244 31.3073 77.6166 29.9409 77.6166H6.43918C5.07278 77.6166 3.96497 78.7244 3.96497 80.091V98.5349"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.2913 5.94528V1.46481"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.5547 19.2086H97.035"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.6699 9.83002L91.8383 6.66185"
            stroke="black"
            strokeWidth="2.92969"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2026_15606">
          <rect width="100" height="100" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
